import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function PaymentVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const order_id = params.get("order_id");
      if (!order_id) { navigate("/app/billing"); return; }
      try {
        await api.post("/payments/verify", { order_id, payment_id: `pay_${Date.now()}` });
        toast.success("Payment successful — plan upgraded!");
        navigate("/app/billing");
      } catch (e) {
        toast.error("Payment verification failed");
        navigate("/app/billing");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg">
      <div className="bg-white p-10 rounded-3xl border border-brand-borderc shadow-soft text-center">
        <Loader2 className="w-10 h-10 mx-auto text-brand-purple animate-spin" />
        <div className="mt-3 text-brand-navy font-semibold">Verifying payment…</div>
      </div>
    </div>
  );
}
